import { createFileRoute } from '@tanstack/react-router'
import { PointCloudHome } from 'pages/pointClouds/PointCloudHome'

export const Route = createFileRoute('/point-cloud/$siteID')({
  component: PointCloudHome,
  staticData: {
    title: 'Point Cloud',
  },
})
